import { Zap, MessageCircle, Globe } from "lucide-react";
import { WHATSAPP_LINK } from "../constants/config";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-gray-950 text-white py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-xl bg-[#E60000] flex items-center justify-center">
              <Zap className="w-5 h-5 text-white" strokeWidth={2.5} />
            </span>
            <span className="font-heading font-extrabold text-xl tracking-tight">
              Risma<span className="text-[#E60000]">Cell</span>
            </span>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed mt-4 max-w-xs">
            Jasa migrasi paket IndiHome ke paket retensi — tagihan lebih murah,
            proses cepat, dibantu sampai selesai.
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-gray-400">
            Navigasi
          </h3>
          <ul className="mt-4 space-y-3">
            <li>
              <a href="#cara-kerja" className="text-sm text-gray-300 hover:text-white transition-colors">
                Cara Kerja
              </a>
            </li>
            <li>
              <a href="#paket" className="text-sm text-gray-300 hover:text-white transition-colors">
                Paket Retensi
              </a>
            </li>
            <li>
              <a href="#order" className="text-sm text-gray-300 hover:text-white transition-colors">
                Order Sekarang
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-gray-400">
            Kontak
          </h3>
          <ul className="mt-4 space-y-3">
            <li>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
              >
                <MessageCircle className="w-4 h-4 text-[#25D366]" />
                Chat WhatsApp
              </a>
            </li>
            <li className="flex items-center gap-2 text-sm text-gray-300">
              <Globe className="w-4 h-4 text-gray-500" />
              Melayani seluruh Indonesia (online)
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 mt-12 pt-8 border-t border-white/10">
        <p className="text-xs text-gray-500">
          © {new Date().getFullYear()} RismaCell. RismaCell adalah jasa pihak
          ketiga dan bukan bagian resmi dari IndiHome/Telkom Indonesia.
        </p>
      </div>
    </footer>
  );
};
